import script from "./SliderBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderBlock.vue?vue&type=script&setup=true&lang=js"

import "./SliderBlock.vue?vue&type=style&index=0&id=f5ef6968&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ef6968"]])

export default __exports__